import React, { useEffect, useState } from 'react'
import Section from '../../SectionTitle/Section'
import SectionTitle from '../../SectionTitle/SectionTitle'
import styles from './styles.module.scss'
import { Link } from 'react-router-dom'
import getApi from '../../../http/getApi'
import Card from '../../Card/Card'
import Loading from '../../Loading/Loading'
import { SectionLink } from '../../SectionTitle/SectionLink'
import { useLanguage } from '../../../context/LanguageContext'

export const LatestEvents = () => {
    const {language} = useLanguage()
    const [load, setLoad] = useState(true)
    const [data, setData] = useState([]);
    const [params, setParams] = useState({
        page: 1,
        limit: 2
    });
    const [totalPages, setTotalPages] = useState(1);
    useEffect(() => {
        async function fetchData() {
            try {
                const queryString = new URLSearchParams(params).toString();
                const blogs = await getApi.getData(`/events?${queryString}`);
                setData(blogs.data); // თუ გაქვს pagination სტრუქტურა, დაარეგულირე
                setTotalPages(blogs.totalPages); // თუ გიგზავნის საერთო გვერდებს
            } catch (err) {
                console.error('Error fetching blogs:', err);
            } finally {
                setLoad(false)
            }
        }

        fetchData();
    }, [params]);

    const sectionTitle = {
        ka: 'ღონისძიებები',
        en: 'EVENTS',
        ru: 'イベント',
    }

    return (
        <Section bgColor={'#e5e7eb'}>
            <SectionTitle title={sectionTitle[language]} />
            {load && <Loading />}
            <div className='row'>
                {data && data?.map((item) => {
                    return (
                        <div className='col-lg-6' key={item._id}>
                            <Card
                                cover={item.cover}
                                title={item.title[language]}
                                desc={item.desc[language]}
                                url={`/events/${item._id}`}
                            />
                        </div>
                    )
                })}
            </div>
            <div className='d-flex justify-content-center'>
                <SectionLink link={'/events'} text={'View All'} />
            </div>
        </Section>
    )
}
